import {CustomerGroupPrice, updatedProductGroupToggle} from "../../../services/productGroupService";
import {useDispatch, useSelector} from "react-redux";
import {IGlobalProduct, IState} from "../../../types/state";
import React, {FC, Fragment, MouseEvent as ReactMouseEvent, ReactNode, useEffect, useRef, useState} from "react";
import {useToast} from "../../../atoms/Toast/useToast";
import {useRouter} from "next/router";
import cls from "./customInnerPage.module.scss";
import {CheckToastSvg, FailSvg, HeartActive, HeartSvg} from "../../../svg";
import {wishlistAddItem, wishlistRemoveItem} from "../../../store/wishlist";
import Script from "next/script";
import {IProduct, TranslationsType} from "../../../types/homePageTypes";
import CustomDetails from "./CustomDetails";
import {ICurrencies} from "../Wrappers/MainLayout";
import {ICustomerGroupPrices} from "../../../pages/[productSlug]";
import CustomSideBar from "./CustomSideBar";
import CustomQuantityTable from "./CustomQuantityTable";
import CustomSocialLinks from "./CustomSocialLinks";
import CustomDetailTabButtons from "./CustomDetailTabButtons";
import CustomInfoPart from "./CustomInfoPart";
import {
    addCartDivStyleToggleSimple,
    dangerOrSuccessStyleSimple,
    isSelectedDetailSectionClass,
    openedBoxStyles,
    schemaProduct,
    showBoxAboutDetails,
    useFetchCartToken
} from "./helpers";
import CustomProductGallery from "./CustomProductGallery";
import InputNumber from "../../shared/InputNumber";
import {handleAddCard, openUpCrossProd} from "../../shared/ProductCard/helpers";

interface ICustomProduct {
    dbName: string;
    domain: string;
    productSlug: string;
    selectedRate: ICurrencies;
    product: IProduct;
    backOrderValue: string;
    customerGroupPrices: Array<ICustomerGroupPrices>;
    translationsData: TranslationsType;
    selectedLocale: string;
    schemaBrandName: string;
    showDetailsInFront: boolean;
    showBuilderComponents: (id: number) => Record<"true" | "false", ReactNode>;
    showBuilderData: boolean;
}

const CustomProduct: FC<ICustomProduct> = (
    {
        dbName,
        productSlug,
        domain,
        selectedRate,
        product,
        backOrderValue,
        customerGroupPrices,
        translationsData,
        selectedLocale,
        schemaBrandName,
        showDetailsInFront,
        showBuilderComponents,
        showBuilderData
    }
) => {
    const [open, setOpen] = useState<boolean>(false);
    const [optionValues, setOptionValues] = useState<{
        id: number;
        label: string;
        price: string;
        optionId: number
    }[]>([]);
    const [clientSideProduct, setClientSideProduct] = useState<IProduct>(product);

    const [resultFilterGroup, setResultFilterGroup] = useState<{
        element: CustomerGroupPrice[];
        display: "flex" | "none"
    }>({
        element: [],
        display: "none"
    })
    const {
        flats: [{
            name: productName = "",
            description: productDesc = "",
            min_price: productMinPrice = null,
            special_price: productSpecialPrice = null,
            short_description: productShortDesc = "",
            price: productPrice = null,
            price_html: productPriceHtml = null,
            min_qty: productMinQtyServer = 1
        } = {}] = [],
        images: [productImgPath = ""] = [],
        id: productId,
        sku: productSku = "",
        details: productDetails = [],
        sku_option: {name: productSkuOptionName = "SKU"} = {},
        short_description_option: {name: productShortDescOptionName = ""} = {},
        description_option: {name: productDescOptionName = ""} = {},
        product_options = [],
        qty: [productInitialQty]
    } = product
    const productMinQty = !(!!productMinQtyServer) || !(!!+productMinQtyServer) ? 1 : productMinQtyServer;
    const [productQuantity, setProductQuantity] = useState<number>(productMinQty || 1);
    useEffect(() => {
        setProductQuantity(productMinQty);
        setClientSideProduct(product)
    }, [productSlug]);

    const [isSelectDetail, setIsSelectDetail] = useState<boolean>(!productDesc);
    const cartToken = useSelector((state: IState) => state.cartToken);
    const {customerGroupId, token: customerToken} = useSelector((state: IState) => state.customer);
    const signed = useSelector((state: IState) => state.customer.authenticated);
    const wishlist = useSelector((state: IState) => state.wishlist);
    const isProductInWishList = wishlist?.find((item: IGlobalProduct) => item.id === productId)
    const [wishIcon, setWishIcon] = useState<React.JSX.Element>(<HeartSvg/>)
    useEffect(() => {
        setWishIcon(!!isProductInWishList ? <HeartActive className={cls["inner-wishlist"]}/> : <HeartSvg/>)
    }, [isProductInWishList]);
    const dispatch = useDispatch();
    const toast = useToast();
    const {asPath, push: routerPush} = useRouter();
    const rootRef = useRef<HTMLDivElement>(null)

    const isProductInStock = product.qty[0] > 0 || !!parseFloat(backOrderValue)
    const addToast = (error?: boolean) => {
        if (error) {
            toast.open(
                <span className="d-flex chek-fms">
                    <FailSvg/>
                    {translationsData.ProductNotAvailable}
                </span>
            )
        } else {
            if (isProductInStock) {
                toast.open(
                    <span className="d-flex chek-fms">
                        <CheckToastSvg/>
                        {translationsData.ToastAddToCart}
                   </span>
                )
            }
        }
    }

    useEffect(() => {
        const handleGroupPriceDisplay: { true: "flex", false: "none" } = {
            "true": "flex",
            "false": "none"
        }
        setResultFilterGroup({
            element: updatedProductGroupToggle(
                customerGroupPrices,
                customerGroupId,
                product,
                true,
                selectedRate?.exchange_rate?.rate || "1"
            ),
            display: handleGroupPriceDisplay[`${!!customerGroupPrices.length}`]
        })
    }, [productSlug]);

    const schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName)

    useEffect(() => {
        const handleEvent = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleEvent)
        return () => document.removeEventListener('mousedown', handleEvent)
    }, [])


    const toggleOptionValue = (id: number, label: string, price: string, optionId: number) => {
        const handleOptionId = optionValues.find((el) => el?.id === id);
        const handleOptionLabel = optionValues.find((el) => el?.label === label);
        const previousStateHandle = (el: { id: number, label: string, price: string, optionId: number }) => {
            return {
                "true": {...el, label, price, optionId},
                "false": el
            }
        }
        const handleOptions = {
            "true": {
                "true": () => {
                },
                "false": () => setOptionValues((prev) => prev.map((el) => previousStateHandle(el)[`${el.id === id}`])
                )
            },
            "false": {
                "true": () => setOptionValues((prev) => [...prev, {id, label, price, optionId}]),
                "false": () => setOptionValues((prev) => [...prev, {id, label, price, optionId}]),
            }
        }
        handleOptions[`${!!handleOptionId}`][`${!!handleOptionLabel}`]()
    };

    const customOptions = {
        "customizable_options": optionValues.reduce((result: Record<string, number>, value) => {
            result[`${value.id}`] = value.optionId;
            return result;
        }, {}),
    };
    const handleAmdPrice = ({ code: currCode }: ICurrencies, price: number) => {
        const currentCurrCodeIsAmd = currCode.toLowerCase() === "amd";
        if (!currentCurrCodeIsAmd) {
            return Number(price).toFixed(2)
        }
        return +price
    }

    useEffect(() => {
        const priceArray = optionValues.map((element) => parseFloat(element.price));
        const concatenatedString = priceArray.reduce(
            (accumulator, currentValue) => accumulator + currentValue, 0
        ).toString() + '.000';
        setClientSideProduct((prev: IProduct) => {
            const newProductFlat = {...prev.flats[0]};
            const defaultMinPrice = parseFloat(productMinPrice) || 0;
            const defaultSpecialPrice = parseFloat(productSpecialPrice) || 0;
            const defaultPrice = parseFloat(productPrice) || 0;
            const newPrice = defaultPrice + parseFloat(concatenatedString) || 0;
            newProductFlat.price = String(handleAmdPrice(selectedRate, newPrice)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const newFlatPriceHandle = {
                minToggle: {
                    "true": () => {
                        const newMinPrice = defaultMinPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.min_price = String(handleAmdPrice(selectedRate, newMinPrice)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    },
                    "false": () => {
                    },
                },
                specialToggle: {
                    "true": () => {
                        const newSpecialPrice = defaultSpecialPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.special_price = String(handleAmdPrice(selectedRate, newSpecialPrice)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    },
                    "false": () => {
                    }
                }
            }
            newFlatPriceHandle.minToggle[`${productMinPrice !== null}`]();
            newFlatPriceHandle.specialToggle[`${!!productSpecialPrice}`]();

            return {
                ...prev,
                flats: [newProductFlat],
            };
        })
        localStorage.setItem("customOptions", JSON.stringify(customOptions))
    }, [optionValues, asPath, productSlug])

    useFetchCartToken(cartToken)

    const maxQty = {
        "true": 50000,
        "false": product?.qty[0]
    };

    const optionIdShowToggle = (elemId: number, elemTitle: string) => {
        const sequenceOptionCorrect = {
            "true": () => {
                return <div>{elemTitle}</div>
            },
            "false": () => {
                const foundOption = optionValues.find((item) => item.id === elemId)
                const findElem = {
                    "true": <div>{foundOption?.label}</div>,
                    "false": <div>{elemTitle}</div>
                }
                return findElem[`${!!foundOption}`]
            }
        }
        return sequenceOptionCorrect[`${optionValues.length === 0}`]()
    }

    const selectTab = (e: ReactMouseEvent<HTMLDivElement>) => {
        setIsSelectDetail((e.target as HTMLDivElement).id === "detail")
    }
    const quantityColumnHandler = (title: string, isQuantity: boolean) => {
        const handleQuantity = ({qty, value}: { qty: string; value: string | number }) => {
            return {
                "true": {
                    divTableStyle: {background: "#EFEFEF"},
                    priceClassToggle: "quantity_item_span",
                    priceSpan: qty,
                    titleSpan: translationsData?.AndMore
                },
                "false": {
                    divTableStyle: {},
                    priceClassToggle: "price_item_span",
                    priceSpan: `${selectedRate?.symbol}${value}`,
                    titleSpan: ""
                }
            }
        }
        return (
            <div className={cls["quantity_table_row"]}>
                <div style={handleQuantity({qty: "", value: ""})[`${isQuantity}`].divTableStyle}
                     className={cls["quantity_table_item"]}>
                <span className={cls["quantity_item_span"]}>
                    {translationsData?.[title]}
                </span>
                </div>
                {resultFilterGroup.element.map((groupItem: { qty: string; value: string | number }) => (
                    <div style={handleQuantity(groupItem)[`${isQuantity}`].divTableStyle}
                         className={cls["quantity_table_item"]}>
                    <span className={cls[handleQuantity(groupItem)[`${isQuantity}`].priceClassToggle]}>
                        {handleQuantity(groupItem)[`${isQuantity}`].priceSpan}
                        {" "}
                        {handleQuantity(groupItem)[`${isQuantity}`].titleSpan}
                    </span>
                    </div>
                ))}
            </div>
        )
    }
    const handleWishIconClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        if (!signed) {
            toast.open(
                <span className="d-flex faild-toast-fms">
                    <FailSvg/>
                    {translationsData.ToastSignIn}
                </span>
            )
        } else {
            !!isProductInWishList ?
                dispatch(wishlistRemoveItem(product.id))
                : dispatch(wishlistAddItem(product, selectedLocale))
            const toastChildren = {
                "true": {svg: <FailSvg/>, title: translationsData?.ToastWishListRemove},
                "false": {svg: <CheckToastSvg/>, title: translationsData?.ToastWishList}
            }
            toast.open(
                <span className="d-flex faild-toast-fms">
                    {toastChildren[`${!!isProductInWishList}`].svg}
                    {toastChildren[`${!!isProductInWishList}`].title}
                </span>
            )
        }
    }

    const priceHtmlAvailable = {
        "true": product?.flats[0]?.price_html?.map((e: string, i: number) => (
            <span key={i} className={cls["product_price_html"]}>{e}</span>
        )),
        "false": <></>
    }

    const handleZero = (value: number) => {
        return {
            true: value,
            false: 1
        }
    }

    const handleCustomerGroupPrice = {
        "true": <CustomQuantityTable
            QuantityDiscount_INTL={translationsData?.QuantityDiscount}
            quantityColumnHandler={quantityColumnHandler}
            displayFilterGroup={resultFilterGroup.display}
        />,
        "false": null
    }

    const isButtonDisabled = {
        "true": !(!!+backOrderValue),
        "false": false
    }


    const descriptions = (
        <div className="product-inner-long-description">
            <div style={{paddingLeft: "30px"}}>
                <div dangerouslySetInnerHTML={{__html: productDesc}}/>
            </div>
        </div>
    )

    const details = <CustomDetails
        details={productDetails}
        isSelectDetail={isSelectDetail}
        showDetailsInFront={showDetailsInFront}
        translationsData={translationsData}
        dbName={dbName}
        domain={domain}
    />
    const handleAddCartClickLocal = async (quantity: number = 1) => {
        return await handleAddCard({
            openUpCrossProd: () => {
                return openUpCrossProd(
                    {
                        dispatch,
                        productId,
                        selectedLocale,
                        selectedRate,
                        product
                    }
                )
            },
            dispatch,
            data: {
                product,
                quantity,
                cartToken,
                customer: { token: customerToken },
                selectedLocale,
                selectedCurrCode: selectedRate.code,
                optionsObject: null,
                addToast
            },
            routerPush,
            isProductInStock,
        })
    }

    return (
        <Fragment>
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
                defer
            />
            <div>
                <div className={cls["product__content"]}>
                    <CustomProductGallery images={product.images} dbName={dbName}/>
                    <div className={cls.product__info}>
                        <CustomInfoPart
                            product={product}
                            productName={productName}
                            productSkuOptionName={productSkuOptionName}
                            productSku={productSku}
                            selectedCurrSymbol={selectedRate?.symbol}
                            selectedCurrCode={selectedRate?.code}
                            clientSidePrice={{
                                price: clientSideProduct.flats[0].price,
                                specialPrice: clientSideProduct.flats[0].special_price || 0
                            }}
                            priceHtmlAvailable={priceHtmlAvailable[`${!!productPriceHtml}`]}
                            productShortDescOptionName={productShortDescOptionName}
                            productShortDesc={productShortDesc}
                            productOptions={product_options}
                            optionIdShowToggle={optionIdShowToggle}
                            arrowClassName={openedBoxStyles[`${open}`].arrowClass}
                            dropdownDisplay={openedBoxStyles[`${open}`].display}
                            rootRef={rootRef}
                            setOpen={setOpen}
                            toggleOptionValue={toggleOptionValue}
                        >
                            {handleCustomerGroupPrice[`${resultFilterGroup.element.length > 0}`]}
                        </CustomInfoPart>
                        <div className={cls.sidebar__details}>
                            {!showDetailsInFront && !!productDetails.length && <CustomDetails
                                details={productDetails}
                                isSelectDetail={isSelectDetail}
                                showDetailsInFront={true}
                                translationsData={translationsData}
                                dbName={dbName}
                                domain={domain}
                            />}
                        </div>
                        <ul className={`${cls.product__meta} ${cls.simple__meta}`}>
                            <li className={cls["product__meta-availability"]}>
                                <span className={dangerOrSuccessStyleSimple[`${isProductInStock}`].className}
                                      style={{fontSize: "18px"}}>
                                    {translationsData?.[dangerOrSuccessStyleSimple[`${isProductInStock}`].ItlKey]}
                                </span>
                            </li>
                            <div className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>
                                <InputNumber
                                    id="product-quantity"
                                    aria-label="Quantity"
                                    className={cls["product__quantity"]}
                                    size="lg"
                                    min={handleZero(productMinQty)[`${!!productMinQty}`]}
                                    max={maxQty[`${!!backOrderValue}`]}
                                    value={handleZero(productQuantity)[`${!!productQuantity}`]}
                                    onChange={(quantity: number) => setProductQuantity(quantity)}
                                />
                            </div>
                        </ul>
                        <CustomSideBar
                            ProductAddToCart_INTL={translationsData?.AddToCartButtonTitle}
                            actionClassName={addCartDivStyleToggleSimple[`${isProductInStock}`]}
                            handleCardClick={handleAddCartClickLocal}
                            isButtonDisabled={isButtonDisabled[`${productInitialQty === 0}`]}
                            wishListButtonClick={handleWishIconClick}
                            wishIconClicked={wishIcon}
                            minimalQty={handleZero(productMinQty)[`${!!productMinQty}`]}
                            maximalQty={maxQty[`${!!backOrderValue}`]}
                            inpValQuantity={handleZero(productQuantity)[`${!!productQuantity}`]}
                            setQuantity={setProductQuantity}
                        />
                        <CustomSocialLinks dbName={dbName} domain={domain} productSlug={productSlug}/>
                    </div>
                </div>
                {showBuilderComponents(2)[`${showBuilderData}`]}
                <CustomDetailTabButtons
                    boxAboutDetailsClass={showBoxAboutDetails[`${showDetailsInFront}`]}
                    isSelectedDetailSectionClass={isSelectedDetailSectionClass(descriptions, details)[`${isSelectDetail}`]}
                    productDescOptionName={productDescOptionName}
                    Details_INTL={translationsData?.Details}
                    selectTab={selectTab}
                    showDescription={!!productDesc}
                    showDetailsInFront={showDetailsInFront}
                />
                {isSelectedDetailSectionClass(descriptions, details)[`${isSelectDetail}`].content}
            </div>
        </Fragment>
    );
};

export default CustomProduct;
